/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography } from '@coursera/cds-core';
import { Col, Row, color } from '@coursera/coursera-ui';

import DomainTopSkillPill from 'bundles/browse/components/Domain/DomainTopSkillPill';
import type { Skill } from 'bundles/browse/components/Domain/types/Domain';
import { SCREEN_TABLET } from 'bundles/browse/constants';

import _t from 'i18n!nls/browse';

type Props = {
  topicsList?: Array<Skill>;
};

const style = css`
  display: flex;
  flex-direction: column;
  margin-bottom: 75px;

  @media (max-width: 1023px) {
    margin-top: 60px;
  }

  .popular-topics-title {
    line-height: 1.5rem;
    margin-bottom: 1.25rem;
  }

  .domainSkillsRow {
    margin: 0 !important;

    .domainSkillsColumn {
      width: fit-content !important;
      max-width: fit-content !important;
      margin-right: 15px;
      margin-bottom: 20px;
      padding: 0 !important;

      > a {
        /* override StatusPill styling */
        border-radius: 2px !important;
        border: 1px solid var(--cds-color-grey-600) !important;
      }

      > * {
        /* force CDS typography */

        /* theme.typography.body2 */
        font-size: 0.875rem;
        line-height: 1.25rem;
        font-family: 'Source Sans Pro', Arial, sans-serif;
        font-weight: normal;
        font-style: normal;
      }

      @media (max-width: ${SCREEN_TABLET}px) {
        margin-bottom: 16px;
      }
    }
  }
`;

const renderDomainTopTopic = (topic: Skill, topicIndex: number): React.ReactNode => {
  return (
    <Col key={topicIndex} rootClassName="domainSkillsColumn" col sm={6} md={3} role="listitem">
      <DomainTopSkillPill {...topic} textColor={color.darkPrimary} />
    </Col>
  );
};

export function DomainPopularTopics(props: Props) {
  const { topicsList } = props;

  if (!topicsList || !topicsList.length) {
    return null;
  }

  return (
    <div css={style}>
      <Typography className="popular-topics-title" variant="h1" component="h3">
        {_t('Popular Topics')}
      </Typography>
      <Row rootClassName="domainSkillsRow" role="list">
        {topicsList.map((topic, index) => renderDomainTopTopic(topic, index))}
      </Row>
    </div>
  );
}

export default DomainPopularTopics;
